<template>
  <div class="header-title header-title-text title-notab">
    <v-row class="pa-7 mt-5 d-flex">
      <!-- <v-col cols="" class="ma-lg-5"> -->
        <span>จัดการพนักงาน</span>
        <v-spacer></v-spacer>
      <!-- </v-col> -->
      <!-- <v-col v-if="this.$route.name !== 'manageEmployeeCreate'" cols="12" sm="12" md="6" lg="2" class="pt-0 pb-0 d-flex align-center justify-end mt-1"> -->
        <v-btn
          v-if="this.$route.name !== 'manageEmployeeCreate'"
          outlined
          class="button-color-outline head-search-button mr-5"
          color="#2BA197"
          @click="openDialogUploadEmp()"
        >
          <v-icon left dark class="icon-eye-color" size="14px">fa-cloud-upload-alt</v-icon>
          <!-- <span class="ra-text-in-button"> -->
            อัปโหลดไฟล์
          <!-- </span> -->
        </v-btn>
      <!-- </v-col> -->
      <!-- <v-col v-if="this.$route.name !== 'manageEmployeeCreate'" cols="12" sm="12" md="6" lg="2" class="pt-0 pb-0 d-flex align-center justify-start mt-1 mr-n10"> -->
        <!-- <v-btn
          outlined
          class="ra-button-employee"
          dark
          @click="gotocreate()"
        >
          <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
          <span class="ra-text-in-button-employee">
            เพิ่มพนักงาน
          </span>
        </v-btn> -->
        <v-btn
          v-if="this.$route.name !== 'manageEmployeeCreate'"
          class="button-color-outline head-search-button"
          outlined
          color="#2BA197"
          elevation="0"
          @click="openDialogDownload(tab)"
        >
          <v-icon left size="14px">
            fa-cloud-download-alt
          </v-icon>
          ดาวน์โหลดไฟล์
        </v-btn>
      <!-- </v-col> -->
    </v-row>
    <DialogUploadFile/>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import DialogUploadFile from '../_dialog/dialogUploadFile.vue'

export default {
  components: {
    // OverlayLoading,
    DialogUploadFile
  },
  data () {
    return {
      tab: 0
    }
  },
  mounted () {
    EventBus.$on('CheckTab', this.checkTab)
  },
  created () {
  },
  methods: {
    checkTab (value) {
      this.tab = value
    },
    gotocreate () {
      console.log('Create')
      this.$router.push('manageemployee/create')
    },
    openDialogUploadEmp () {
      EventBus.$emit('opendialogUploadFile')
    },
    openDialogDownload (value) {
      if (value === 0) {
        EventBus.$emit('downloadFileCurrent')
      } else if (value === 1) {
        EventBus.$emit('downloadFileResign')
      } else if (value === 2) {
        EventBus.$emit('downloadFile')
      }
    }
  }
}
</script>

<style scoped>
.ra-button-employee {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding: 9px 24px; */

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-button-upload {
  /* position: absolute; */
  /* height: 72px;
  left: 0px;
  right: 0px;
  top: 0px; */

  /* Color/Other/Background */

  background: #F8F9FA;
}
.ra-text-in-button-employee {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
